import React from 'react';
import type { IconProps } from '../types';

export const Monitor = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Monitor */}
      <rect
        x="3.4195907"
        y="5.5222349"
        width="21.119312"
        height="12.119312"
        rx="1.4399531"
      />

      {/* Stand */}
      <line
        x1="13.979247"
        y1="18.08189"
        x2="13.979247"
        y2="21.08189"
      />

      {/* Base */}
      <line
        x1="8.9792461"
        y1="21.58189"
        x2="18.979248"
        y2="21.58189"
      />
    </g>
  </svg>
);

export default Monitor;
